module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/es.json
// module id = 544
// module chunks = 0